export const recipientErrors = [
  {
    "message": "field_is_required",
    "path": [
      "firstName"
    ],
    "type": "any.required",
    "context": {
      "label": "firstName",
      "key": "firstName"
    }
  },
  {
    "message": "field_is_required",
    "path": [
      "lastName"
    ],
    "type": "any.required",
    "context": {
      "label": "lastName",
      "key": "lastName"
    }
  },
  {
    "message": "field_is_required",
    "path": [
      "phoneNumber"
    ],
    "type": "any.required",
    "context": {
      "label": "phoneNumber",
      "key": "phoneNumber"
    }
  },
  {
    "message": "\"documentType\" is required",
    "path": [
      "documentType"
    ],
    "type": "any.required",
    "context": {
      "label": "documentType",
      "key": "documentType"
    }
  },
  {
    "message": "field_is_required",
    "path": [
      "passportOrIdSerialNumber"
    ],
    "type": "any.required",
    "context": {
      "label": "passportOrIdSerialNumber",
      "key": "passportOrIdSerialNumber"
    }
  },
  {
    "message": "field_is_required",
    "path": [
      "email"
    ],
    "type": "any.required",
    "context": {
      "label": "email",
      "key": "email"
    }
  }
]